import axios from 'axios';

interface ErrorPayload {
  message?: unknown;
}

export function getApiErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  if (!axios.isAxiosError<ErrorPayload>(error)) {
    return error instanceof Error && error.message ? error.message : fallback;
  }

  const message = error.response?.data.message;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }
  if (Array.isArray(message)) {
    const validMessages = message.filter(
      (item): item is string =>
        typeof item === 'string' && Boolean(item.trim()),
    );
    if (validMessages.length > 0) return validMessages.join(', ');
  }

  return fallback;
}
